import { createRouter, createWebHashHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'
import type { App } from 'vue'
import { Layout } from '@/utils/routerHelper'
import { useI18n } from '@/hooks/web/useI18n'

const { t } = useI18n()

export const constantRouterMap: AppRouteRecordRaw[] = [
  {
    path: '/',
    component: Layout,
    redirect: '/home',
    name: 'Root',
    meta: {
      hidden: true
    }
  },
  {
    path: '/home',
    component: Layout,
    name: 'HomeRoot',
    meta: {
      hidden: true
    },
    children: [
      {
        path: '',
        name: 'Home',
        component: () => import('@/views/Home/Home.vue'),
        meta: {
          title: '首页',
          icon: 'ep:home-filled',
          affix: true
        }
      }
    ]
  },
  {
    path: '/redirect',
    component: Layout,
    name: 'Redirect',
    children: [
      {
        path: '/redirect/:path(.*)',
        name: 'RedirectPage',
        component: () => import('@/views/Redirect/Redirect.vue'),
        meta: {}
      }
    ],
    meta: {
      hidden: true,
      noTagsView: true
    }
  },
  {
    path: '/login',
    component: () => import('@/views/Login/Login.vue'),
    name: 'Login',
    meta: {
      hidden: true,
      title: t('router.login'),
      noTagsView: true
    }
  },
  {
    path: '/404',
    component: () => import('@/views/Error/404.vue'),
    name: 'NoFind',
    meta: {
      hidden: true,
      title: '404',
      noTagsView: true
    }
  }
]

export const asyncRouterMap: AppRouteRecordRaw[] = [
  {
    path: '/member',
    component: Layout,
    redirect: '/member/system-banner',
    name: 'Member',
    meta: {
      title: '会员管理',
      icon: 'ep:user'
    },
    children: [
      {
        path: 'system-banner',
        name: 'MemberSystemBanner',
        component: () => import('@/views/Member/SystemBanner/index.vue'),
        meta: {
          title: 'APP轮播图'
        }
      },
      {
        path: 'member-benefit-banner',
        name: 'MemberBenefitBanner',
        component: () => import('@/views/Member/MemberBenefitBanner/index.vue'),
        meta: {
          title: '会员权益轮播图'
        }
      }
    ]
  },
  {
    path: '/system',
    component: Layout,
    redirect: '/system/user',
    name: 'System',
    meta: {
      title: '系统管理',
      icon: 'carbon:skill-level-advanced'
    },
    children: [
      {
        path: 'user',
        name: 'SystemUser',
        component: () => import('@/views/System/User.vue'),
        meta: {
          title: '用户管理'
        }
      },
      {
        path: 'role',
        name: 'SystemRole',
        component: () => import('@/views/System/Role.vue'),
        meta: {
          title: '角色管理'
        }
      },
      {
        path: 'menu',
        name: 'SystemMenu',
        component: () => import('@/views/System/Menu.vue'),
        meta: {
          title: '菜单管理'
        }
      },
      {
        path: 'dict',
        name: 'SystemDict',
        component: () => import('@/views/System/Dict/index.vue'),
        meta: {
          title: '字典管理'
        }
      },
      {
        path: 'manual',
        name: 'SystemManual',
        component: () => import('@/views/System/Manual/index.vue'),
        meta: {
          title: '使用手册管理'
        }
      },
      {
        path: 'couponPlatform/index',
        name: 'SystemCouponPlatform',
        component: () => import('@/views/System/CouponPlatform/index.vue'),
        meta: {
          title: '优惠券平台管理'
        }
      },
      {
        path: 'functionCoupon/index',
        name: 'SystemFunctionCoupon',
        component: () => import('@/views/FunctionCoupon/index.vue'),
        meta: {
          title: '功能券管理'
        }
      }
    ]
  },
  {
    path: '/coupon',
    component: Layout,
    redirect: '/coupon/index',
    name: 'Coupon',
    meta: {
      title: '优惠券管理',
      icon: 'ep:ticket'
    },
    children: [
      {
        path: 'index',
        name: 'CouponList',
        component: () => import('@/views/Coupon/index.vue'),
        meta: {
          title: '优惠券管理'
        }
      }
    ]
  },
  {
    path: '/box',
    component: Layout,
    redirect: '/box/box-collection',
    name: 'Box',
    meta: {
      title: '箱子管理',
      icon: 'carbon:skill-level-advanced'
    },
    children: [
      {
        path: 'box-collection',
        name: 'BoxCollection',
        component: () => import('@/views/Box/Collection/CollectionPage.vue'),
        redirect: '/box/box-collection',
        meta: {
          title: '集合箱列表',
          icon: 'mdi:archive-outline',
          affix: true
        }
      },
      {
        path: 'box-collection-detail',
        component: () => import('@/views/Box/Collection/CollectionDetail.vue'),
        name: 'BoxCollectionDetail',
        meta: {
          title: '集合箱详情',
          noTagsView: true,
          noCache: true,
          hidden: true,
          canTo: true,
          activeMenu: '/box/box-collection'
        }
      }
    ]
  },
  {
    path: '/task',
    component: Layout,
    redirect: '/task/tall-box-putaway',
    name: 'Task',
    meta: {
      title: '任务管理',
      icon: 'hugeicons:task-daily-01'
    },
    children: [
      {
        path: 'call-box-putaway-list',
        name: 'CallBoxPutawayList',
        component: () => import('@/views/Task/CallBoxPutaway/list.vue'),
        redirect: '/task/call-box-putaway',
        meta: {
          title: '叫箱上架',
          noTagsView: true,
          noCache: true,
          hidden: true,
          canTo: true,
          activeMenu: '/task/call-box-putaway'
        }
      },
      {
        path: 'call-box-putaway-detail',
        component: () => import('@/views/Task/CallBoxPutaway/detail.vue'),
        name: 'CallBoxPutawayDetail',
        meta: {
          title: '叫箱上架',
          noTagsView: true,
          noCache: true,
          hidden: true,
          canTo: true,
          activeMenu: '/task/call-box-putaway'
        }
      },
      {
        path: 'call-box-putaway',
        component: () => import('@/views/Task/CallBoxPutaway/select.vue'),
        name: 'CallBoxPutaway',
        meta: {
          title: '叫箱上架',
          icon: 'mdi:archive-arrow-up-outline',
          affix: true
        }
      }
    ]
  },
  {
    path: '/logicsPackageStatistics',
    component: Layout,
    redirect: '/logicsPackageStatistics/index',
    name: 'LogicsPackageStatisticsRoot',
    meta: {
      title: '物流包裹统计',
      icon: 'ep:goods'
    },
    children: [
      {
        path: 'index',
        name: 'LogicsPackageStatistics',
        component: () => import('@/views/LogicsPackageStatistics/index.vue'),
        meta: {
          title: '物流包裹统计'
        }
      }
    ]
  },
  {
    path: '/logisticsCarrier',
    component: Layout,
    redirect: '/logisticsCarrier/index',
    name: 'LogisticsCarrier',
    meta: {
      title: '物流公司管理',
      icon: 'ep:office-building'
    },
    children: [
      {
        path: 'index',
        name: 'LogisticsCarrierList',
        component: () => import('@/views/LogisticsCarrier/index.vue'),
        meta: {
          title: '物流公司管理'
        }
      }
    ]
  },
  {
    path: '/appLogisticsDisplayGroup',
    component: Layout,
    redirect: '/appLogisticsDisplayGroup/index',
    name: 'AppLogisticsDisplayGroupRoot',
    meta: {
      title: 'APP配送展示分组',
      icon: 'ep:guide'
    },
    children: [
      {
        path: 'index',
        name: 'AppLogisticsDisplayGroup',
        component: () => import('@/views/AppLogisticsDisplayGroup/index.vue'),
        meta: {
          title: 'APP配送展示分组'
        }
      }
    ]
  },
  {
    path: '/logicsCompanyDesc',
    component: Layout,
    redirect: '/logicsCompanyDesc/index',
    name: 'LogicsCompanyDesc',
    meta: {
      title: '物流线路描述',
      icon: 'ep:location'
    },
    children: [
      {
        path: 'index',
        name: 'LogicsCompanyDescList',
        component: () => import('@/views/LogicsCompanyDesc/index.vue'),
        meta: {
          title: '物流线路描述'
        }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  strict: true,
  routes: constantRouterMap as RouteRecordRaw[],
  scrollBehavior: () => ({ left: 0, top: 0 })
})

export const resetRouter = (): void => {
  const resetWhiteNameList = ['Redirect', 'Login', 'NoFind', 'Root', 'Home', 'HomeRoot']
  router.getRoutes().forEach((route) => {
    const { name } = route
    if (name && !resetWhiteNameList.includes(name as string)) {
      router.hasRoute(name) && router.removeRoute(name)
    }
  })
}

export const setupRouter = (app: App<Element>) => {
  app.use(router)
}

export default router
